import request from "@/utils/request";

export const url = {
  GetDishList: "/api/Restaurant/GetDishList", //获取菜品清单
  CreateMobileOrder: "/api/MobileRestaurant/CreateMobileOrder",
  ConfirmDish: "/api/MobileRestaurant/ConfirmDish",
  GetTableDetail: "/api/MobileRestaurant/GetTableDetail",
  GetTableToken: "/api/MobileRestaurant/GetTableToken", //桌台号换取临时Token,
  OrderDish: "/api/Restaurant/OrderDish", //点菜
  WxPay: "/api/WxPay/H5Pay", //发起H5预支付
  GetOrderDetail: "/api/Restaurant/GetOrderDetail",
  GetWechatInfo: "/api/WxAuth/GetWechatInfo", //获取微信信息 For餐饮移动下单使用
  GetPayResult: "/api/WxPay/GetPayResult",
  GetMyOrder: "/api/MobileRestaurant/GetMyOrder",
  GetRestaurantConfig: "/api/MobileRestaurant/GetRestaurantConfig", //获取餐饮配置

  BookingOrder: "/api/Restaurant/BookingOrder", //订餐
  EditBookingOrder: "/api/Restaurant/EditBookingOrder", //修改订餐信息
  GetBookingOrderPage: "/api/Restaurant/GetBookingOrderPage", //客人订餐列表
  GetRestaurantGallery: "/api/MobileRestaurant/GetRestaurantGallery",
  GetPayOrderId: "/api/WxPay/GetPayOrderId", //获取本次预支付的商户订单号
  PollingGetPayResult: "/api/WxPay/PollingGetPayResult", //轮询获取支付结果，发起H5预支付时调用
  GetMemberByPhone: "/api/MobileRestaurant/GetMemberByPhone",
};
function sendRequest(apiUrl, params, type, opt = {}) {
  return request({
    ...opt,
    url: apiUrl,
    method: type,
    data: params,
  });
}

export default class restaurantApi {
  static getMemberByPhone(params, type = "post") {
    return sendRequest(url.GetMemberByPhone, params, type);
  }
  static getPayOrderId(params, type = "post") {
    return sendRequest(url.GetPayOrderId, params, type);
  }
  static pollingGetPayResult(params, type = "post") {
    return sendRequest(url.PollingGetPayResult, params, type);
  }
  static getRestaurantGallery(params, type = "post") {
    return sendRequest(url.GetRestaurantGallery, params, type);
  }

  static getDishList(params, type = "post") {
    return sendRequest(url.GetDishList, params, type);
  }
  static createMobileOrder(params, type = "post") {
    return sendRequest(url.CreateMobileOrder, params, type);
  }
  static ConfirmDish(params, type = "post") {
    return sendRequest(url.ConfirmDish, params, type);
  }
  static getTableDetail(params, type = "post") {
    return sendRequest(url.GetTableDetail, params, type);
  }
  static getTableToken(params, type = "post") {
    return sendRequest(url.GetTableToken, params, type);
  }
  static orderDish(params, type = "post") {
    return sendRequest(url.OrderDish, params, type);
  }
  static wxPay(params, type = "post") {
    return sendRequest(url.WxPay, params, type);
  }
  static getOrderDetail(params, type = "post") {
    return sendRequest(url.GetOrderDetail, params, type);
  }
  static getWechatInfo(params, type = "post") {
    return sendRequest(url.GetWechatInfo, params, type);
  }
  static getPayResult(params, type = "post") {
    return sendRequest(url.GetPayResult, params, type, {
      headers: {
        loading: "false",
        timeout: 90 * 1000,
      },
    });
  }
  static getMyOrder(params, type = "post") {
    return sendRequest(url.GetMyOrder, params, type);
  }
  static getRestaurantConfig(params, type = "post") {
    return sendRequest(url.GetRestaurantConfig, params, type);
  }

  static bookingOrder(params, type = "post") {
    return sendRequest(url.BookingOrder, params, type);
  }
  static editBookingOrder(params, type = "post") {
    return sendRequest(url.EditBookingOrder, params, type);
  }
  static getBookingOrderPage(params, type = "post") {
    return sendRequest(url.GetBookingOrderPage, params, type);
  }
}
